import React from "react"
import { localizedF } from "js/includes/common/utils"
import { propEq } from "ramda"
import Select from "react-select"

const architectureOptions = [
  { value: "ALL", label: localizedF("general.all") },
  { value: "64_BIT", label: localizedF("general.sixtyFourBit") },
  { value: "32_BIT", label: localizedF("general.thirtyTwoBit") },
]

export default function ArchitectureSelect({ onChange, supportedArchitecture }) {
  return (
    <Select
      {...{
        getOptionLabel: ({ label }) => label(),
        value: architectureOptions.find(propEq("value", supportedArchitecture)),
        options: architectureOptions,
        id: "supportedArchitectureOptions",
        onChange: selection => onChange("supportedArchitecture", selection.value),
      }}
    />
  )
}
